import { useCallback } from 'react';
import { useTraceFiltersContext } from '@/creditflowresearch/application/Trace/TraceFilters/TraceFiltersContext';
import { IParamsInitial, useFiltersContext } from '@/creditflowresearch/application/FiltersContext';
import { useTraceAssetClassesContext } from '@/creditflowresearch/application/Trace/TraceAssetClassesContext';
import { IMarketTradesPayload } from '@/creditflowresearch/domain/vo/Trace/IMarketTradesPayload';
import widenDateToForRpc from '@/creditflowresearch/application/Trace/widenDateToForRpc';

type TgetPayloadProps = { assetClassId?: string, params?: IParamsInitial };

interface IuseGetTracePayloadProps {
  getPayload: ({ assetClassId, params }: TgetPayloadProps) => Partial<IMarketTradesPayload>,
}

const useGetTracePayload = (): IuseGetTracePayloadProps => {
  const { filtersPayload: filter } = useTraceFiltersContext();
  const { params } = useFiltersContext();
  const { currentAssetClass } = useTraceAssetClassesContext();

  const getPayload = useCallback((
      { assetClassId, params: propsParams }: TgetPayloadProps,
  ) => (
      {
        ...params,
        ...propsParams,
        search: propsParams?.search !== undefined ? propsParams.search : params.search,
        filter: widenDateToForRpc({
          ...filter,
          includedAssetClassId: assetClassId || currentAssetClass?.id,
        }),
      }
  ), [params, filter, currentAssetClass]);

  return { getPayload };
};

export default useGetTracePayload;
